import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import { RetailerInfo } from '@/components/RetailerInfo';
import { Retailer } from '@/types';
import 'swiper/css';

const swiperOptions = {
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  modules: [Autoplay],
};

interface RetailerCarouselProps {
  retailers: Retailer[];
}
const RetailerCarousel = (props: RetailerCarouselProps) => {
  const { retailers } = props;
  const navigate = useNavigate();

  if (!retailers) return null;

  return (
    <Swiper {...swiperOptions} className="rounded-base">
      {retailers?.map(
        (retailer) =>
          retailer && (
            <SwiperSlide
              key={retailer.id}
              onClick={() => navigate('/' + retailer.id)}
              className="cursor-pointer"
            >
              <RetailerInfo retailer={retailer as Retailer} />
            </SwiperSlide>
          ),
      )}
    </Swiper>
  );
};

export default RetailerCarousel;
